/********************************* 正在使用的begin ***************************************/
// 保存用户信息
export const SET_ADMIN_INFO = 'SET_ADMIN_INFO'
// 保存前台信息
export const SET_WEB_INFO = 'SET_WEB_INFO'
// 保存前后台页面辅助参数信息
export const SET_PUBLIC_INFO = 'SET_PUBLIC_INFO'
// 保存token
export const SET_TOKEN_INFO = 'SET_TOKEN_INFO'
/********************************* 正在使用的end ***************************************/

// 屏幕大小改变
export const SCREEN_CHANGE = 'SCREEN_CHANGE'
// 注册获取验证码后的读秒59秒
export const SET_WEB_TIME_INFO = 'SET_WEB_TIME_INFO'   
// 后台目录位置记录,保证刷新后还在当前目录名称高亮显示
export const SET_ADMIN_NAVIGATION_INFO  ='SET_ADMIN_NAVIGATION_INFO'
// 后台用户修改密码获取验证码后的读秒59秒
export const SET_ADMIN_TIME_INFO = 'SET_ADMIN_TIME_INFO'
// header
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER'
// 显示右边面板
export const SHOW_RIGHT_NAV = 'SHOW_RIGHT_NAV'
// 是否是管理员页面
export const IS_ADMIN_WRAP = 'IS_ADMIN_WRAP'
// 管理员是否登录
export const IS_LOGIN = 'IS_LOGIN'
// 弹出重新登录提示
export const SHOW_TOKEN_ERROR = 'SHOW_TOKEN_ERROR'
// 保存文章目录信息
export const SET_ARTICLE_MENU = 'SET_ARTICLE_MENU'
// 保存文章目录信息(未生成树的)
export const SET_ARTICLE_MENU_SOURCE = 'SET_ARTICLE_MENU_SOURCE'
// 保存当前为文章第几个目录
export const SET_ARTICLE_MENU_TAG = 'SET_ARTICLE_MENU_TAG'
// 保存评论填写的昵称邮箱信息
export const SET_COMMENTS_INFO = 'SET_COMMENTS_INFO'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js